import { useState } from "react";
import Reveal from "@/pages/home/components/Reveal";
import SectionTitle from "@/pages/home/components/SectionTitle";
import { troubleshoots } from "@/mocks/home";

export default function Troubleshoot() {
  const [active, setActive] = useState<number | null>(0);

  return (
    <section id="trouble" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-14">
          <Reveal>
            <div className="lg:sticky lg:top-28">
              <SectionTitle
                kicker="打不开怎么办"
                title="六种常见场景，对号入座就行"
                desc="不用逐条死磕，找到和你最像的那一条看应对即可。每条都写清了“为什么会这样”和“下一步做什么”。"
              />
              <div className="mt-8 flex flex-wrap gap-2">
                {troubleshoots.map((item, index) => (
                  <button
                    key={item.tag}
                    type="button"
                    onClick={() => setActive(index)}
                    className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
                      active === index
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-800"
                    }`}
                  >
                    {item.tag}
                  </button>
                ))}
              </div>
            </div>
          </Reveal>

          <div className="flex flex-col gap-3">
            {troubleshoots.map((item, index) => {
              const open = active === index;
              return (
                <Reveal key={item.q} delay={index * 60}>
                  <div
                    className={`overflow-hidden rounded-xl border transition-colors ${
                      open ? "border-accent-300 bg-accent-50" : "border-background-200/80 bg-background-100/60"
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setActive(open ? null : index)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="flex items-center gap-3">
                        <span
                          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                            open ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-600"
                          }`}
                        >
                          <i
                            className={open ? "ri-subtract-line text-base" : "ri-add-line text-base"}
                            aria-hidden="true"
                          ></i>
                        </span>
                        <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                          {item.q}
                        </span>
                      </span>
                      <i
                        className={`ri-arrow-down-s-line shrink-0 text-lg text-foreground-500 transition-transform ${
                          open ? "rotate-180" : ""
                        }`}
                        aria-hidden="true"
                      ></i>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ease-out ${
                        open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <div className="space-y-3 px-5 pb-5 pl-16">
                          <p className="flex items-start gap-2 text-sm leading-relaxed text-foreground-700">
                            <i className="ri-error-warning-line mt-0.5 text-base text-primary-600" aria-hidden="true"></i>
                            <span>
                              <strong className="font-semibold text-foreground-900">可能原因：</strong>
                              {item.reason}
                            </span>
                          </p>
                          <p className="flex items-start gap-2 text-sm leading-relaxed text-foreground-700">
                            <i className="ri-lightbulb-flash-line mt-0.5 text-base text-accent-600" aria-hidden="true"></i>
                            <span>
                              <strong className="font-semibold text-foreground-900">可以这样做：</strong>
                              {item.action}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}